<template>

  <div
    class="btn-group">
    <button
      class="btn btn-secondary dropdown-toggle"
      type="button"
      id="dropdownMenuButton2"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false">
      {{ $t('Templates') }}
    </button>
    <div
      class="dropdown-menu"
      aria-labelledby="dropdownMenuButton2"
      style="overflow: auto; max-height: 200px">
      <a
        class="dropdown-item"
        href="javascript:void(0)"
        v-for="(item, index) in templateapplies"
        :key="index"
        @click="setTemplate(item)">
        {{ item.name }}
        </a>
      <div
        v-if="!templateapplies.length"
        class="text-muted p-2">{{ $t('No templates found') }}</div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'TemplateapplySelect',
  props: [
  ],
  data () {
    return {
      templateapplies: []
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.$store
      .dispatch('getTemplateapplies', {sort: 'name', limit: 100})
      .then((result) => {
        this.templateapplies = result.docs
      })
    },
    /*
    setTemplate
    */
    setTemplate (template) {
      const value = this.$clone(template)
      this.$emit('setTemplate', value)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Parts/TemplateapplySelect.vue